import { render, staticRenderFns } from "./topNew.vue?vue&type=template&id=0cc9ea5e&scoped=true&"
import script from "./topNew.vue?vue&type=script&lang=js&"
export * from "./topNew.vue?vue&type=script&lang=js&"
import style0 from "./topNew.vue?vue&type=style&index=0&id=0cc9ea5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc9ea5e",
  null
  
)

export default component.exports